/*
 * @Author: Czy
 * @Date: 2024-09-18 17:55:17
 * @FilePath: /museum-wechat/src/utils/navigateTo.ts
 *
 */
import { obj2Param } from '@/utils'
// import PageInfoType from '@/@type/page'
// import * as loadingStack from './fetch/loadingStack'
interface ObjType {
  [key: string]: any
}
type PageInfoType = {
  [key: string]: { [key: string]: any } | undefined
}
type NavigateToType = 'reLaunch' | 'redirectTo' | 'switchTab' | 'navigateTo'
let currentPath = ''
// 路由跳转 解决堆栈问题
// 进行后退操作 -1 -2 或者 1  2
export function navigateTo(delta: number): Promise<any>
export function navigateTo<T extends keyof PageInfoType>(
  path: T,
  query?: PageInfoType[T],
  type?: NavigateToType,
): Promise<any>
export function navigateTo(path: string, query?: ObjType, type?: NavigateToType): Promise<any>

export function navigateTo(
  value: string | number,
  query?: ObjType,
  type?: NavigateToType,
): Promise<any> {
  return new Promise((resolve, reject) => {
    // loadingStack.clearLoading()
    if (typeof value === 'number') {
      /* #ifdef H5 */
      const pages = getCurrentPages()
      if (pages.length === 1) {
        history.go(-Math.abs(value))
        resolve({})
        return
      }
      /* #endif */

      uni.navigateBack({
        delta: Math.abs(value),
        fail: (err) => {
          reject(err)
        },
        success: (res) => {
          resolve(res)
        },
      })
      return
    }
    const queryStr = query ? '?' + obj2Param(query) : ''
    const path = value + queryStr
    if (path === currentPath) {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject()
      return
    }
    currentPath = path
    if (type === 'reLaunch') {
      uni.reLaunch({
        url: path,
        fail: (err) => {
          reject(err)
        },
        success: (res) => {
          resolve(res)
        },
      })
    } else if (type === 'redirectTo') {
      uni.redirectTo({
        url: path,
        fail: (err) => {
          reject(err)
        },
        success: (res) => {
          resolve(res)
        },
      })
    } else if (type === 'switchTab') {
      uni.switchTab({
        url: path,
        fail: (err) => {
          reject(err)
        },
        success: (res) => {
          resolve(res)
        },
      })
    } else {
      // console.log('跳转', path)

      uni.navigateTo({
        url: path,
        fail: (err) => {
          reject(err)
        },
        success: (res) => {
          resolve(res)
        },
      })
    }

    setTimeout(() => {
      currentPath = ''
    }, 1000)
  })
}
